"use strict";
const declOfNum = require("../declOfNum");
module.exports = function (data) {
  data = data + "";
  return `
         <div class="ch-b_estimate-numbers">
                        <div class="number">
                            <p class="number__text">
                                ${data[0]}
                            </p>
                        </div>
                        <div class="number">
                            <p class="number__text">
                                ${data[1]}
                            </p>
                        </div>
                        <div class="number">
                            <p class="number__text">
                                ${data[2]}
                            </p>
                        </div>
                    </div>
                    <div class="estimate-comment">
                        ${declOfNum(data,["день","дня","дней"])} до<br>
                        Нового года
                    </div>
    `;
};